<template>
    <section>
        <slot/>
    </section>
</template>